import * as angular from 'angular';

import { Pattern, IValueViewModel, ComponentDefinition, Identifier } from '../../models';

class QuerySearchBarController implements angular.IComponentController {
    criteria: Pattern<IValueViewModel>[];
    filteredItems: Identifier[];
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    model: string;
    onChange: ({ value: string }) => void;

    readonly items: Identifier[];
    readonly placeholder: string;
    readonly propertyName: string;

    static $inject = [];

    $onInit() {
        this.criteria = [
            {
                label: 'Identifier name',
                isMatch: () => true,
                model: 'i',
                placeholder: 'Name of the identifier',
                property: 'i'
            },
            {
                label: 'Group',
                isMatch: () => true,
                model: 'g',
                placeholder: 'Search pattern on group',
                property: 'g'
            },
            {
                label: 'Group types',
                isMatch: () => true,
                model: 'gt',
                placeholder: 'Search pattern on group type',
                property: 'gt'
            },
            {
                label: 'Unit',
                isMatch: () => true,
                model: 'u',
                placeholder: 'Search pattern on unit (e.g. bar, °C)',
                property: 'u'
            },
            {
                label: 'Comment',
                isMatch: () => true,
                model: 'c',
                placeholder: 'Search pattern on comment',
                property: 'c'
            },
            {
                label: 'Variable',
                isMatch: () => true,
                model: 'v',
                placeholder: 'Search pattern on variable type (e.g. pressure, temperature)',
                property: 'v'
            },
            {
                label: 'User field',
                isMatch: () => true,
                model: 'ufk',
                placeholder: 'Search pattern on user field key (e.g. BWART=42_AND_UNIT=KG_OR_MATNR=ABC )',
                property: 'ufk'
            }
        ];
    }

    change(value: string) {
        if (this.onChange) {
            this.onChange({ value });
        }
    }
}

export const wtQuerySearchBar: ComponentDefinition = {
    componentId: 'wtQuerySearchBar',
    controller: QuerySearchBarController,
    template: require('./querySearchBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        filteredItems: '=',
        formController: '=?',
        items: '<',
        model: '=?',
        onChange: '&?',
        placeholder: '<',
        propertyName: '<'
    }
};
